<template>
  <v-layout class="inner-pages" column>
    <Header/>

    <scroll-data>
      <h2 class="page-head"><span class="page-heading">Frequently-Asked Questions (FAQs)</span></h2>

      <v-expansion-panel>
        <v-expansion-panel-content expand-icon="expand_more" v-for="item in items"
                                   :key="item.title">
          <div slot="header" class = "blue--text text--darken-4 subheading">{{ item.title }}</div>
          <v-card class="pl-4">
            <p><span v-html="item.content"></span></p>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </scroll-data>

  </v-layout>

</template>

<script>
  import ScrollData from '../../ScrollData'
  import Header from '../../layouts/Header'

  const MAX_LEVEL_TEXT = process.env.GAME_LEVELS_TXT

  export default {
    name: 'Faq',
    components: {ScrollData, Header},
    data () {
      return {
        items: [{
          title: 'What’s a Safe Food Handler GAME?',
          content: `A Safe Food Handler game is like a virtual classroom in which one or more members work to complete
          the certificate program. If someone begins a free trial of the Safe Food Handler certificate program,
          a new game is created for them. They can invite others to join their games.
          <br><br>License fees are reduced for multi-member games.`
        }, {
          title: 'Why use three different PATHS to complete the program?',
          content: `Experienced people, untrained people, and business/classroom organizations all have different needs
          for food safety training. The Fast Path, Master Path, and Team Path describe how the Safe Food Handler app
          supports their needs in different ways.`
        }, {
          title: `What's the FAST PATH?`,
          content: `The Fast Path is how an experienced food handler most efficiently completes the certificate program.
          <ul>
            <li>First, they must use the quiz feature on at least four of the ${MAX_LEVEL_TEXT} levels of instruction. This demonstrates subject
          knowledge.</li>
            <li>They may then take the 40-question exam. They pass with a score of at least 70%, and thereby earn the certificate.</li>
          </ul>`
        }, {
          title: `Why use the MASTER PATH?`,
          content: `The Master Path is how a new or inexperienced food handler builds great expertise.
          Learning Accelerators boost mastery of all ${MAX_LEVEL_TEXT}  levels of course instruction.
          The Master Path Learning Accelerators include:
          <ul>
            <li>Coins and peeks that streamline course-info lookup and learning</li>
            <li>Level skill calculations that show exam readiness for each course-instruction level</li>
            <li>Quiz time tracking that develops confidence and speedy recall</li>
          </ul><p>The Master Path is optional but encouraged because it builds mastery.</p>`
        }, {
          title: `Who would use the TEAM PATH?`,
          content: `When the app is used by a group of people, they use the Team Path. Team Tools enhance group play,
          and support individual use of the Fast Path and Master Path features. The Team Path is recommended for any
          group with a shared interest in food safety. From a few friends and coworkers, or businesses and classrooms
          of hundreds of people.`
        }, {
          title: `What are TEAM TOOLS?`,
          content: `Team Tools make for great group training.
          <ul>
            <li>INVITES are used to ask others to join a Safe Food Handler game. Notice the discounted license fee for training game
            participants</li>
            <li>Designated TRAINERS can follow the progress of new trainees</li>
            <li>Course INSTRUCTION can be presented as part of a physical or virtual classroom, using the App's course material
            and Apple TV (or other digital projection system)</li>
            <li>Group CHALLENGES add fun activities into pre-shift meetings or classrooms</li>
            <li>Use of the STANDINGS page and the Top-5 Most Active list makes for a nice team review of daily or weekly progress</li>
            <li>GAME TRAINING REPORTS summarize participation of group members</li>
          </ul>`
        }, {
          title: `Why INVITE others to your game?`,
          content: `There are two good reasons to invite others to your training game.
          <ol>
            <li>BETTER TRAINING. Training with others increases program success. People actually learn faster and better when training
together. The game lead creates the invite, which is sent by email to the invitee. When they sign in, they are
automatically added to the game.</li>
            <li>LOWER COSTS. Everyone that is part of a multi-member training game gets a discount on the license fee.</li>
          </ol>`
        }, {
          title: `Is a CERTIFICATE like a BADGE?`,
          content: `The certificate is the official record attesting to the completion of the program by an individual.
          It includes all necessary information of who, when, and how. The official certificate is safely held by
          Cogneti in a records vault. The badge is a portable representation of the certificate, designed to be safe
          from loss or misuse. All badges have a unique certificate key that can be used to validate authenticity on
          the cogneti.com website. The badge may be printed, emailed, or otherwise used as evidence.`
        }, {
          title: `How does a CERTIFICATE KEY work?`,
          content: `A certificate key is a unique identifier key attached to each certificate. The key is used to
          identify key certificate items.
          <ol>
            <li>The individual user</li>
            <li>The course of study</li>
            <li>The date and time the user achieved a passing score on the course assessment</li>
          </ol>`
        }, {
          title: `What's LEVEL SKILL?`,
          content: `The level skill is calculated each time a level quiz is completed. Level skill is calculated
          from two measures.
          <ol>
            <li>The subject coverage of all possible topics for the given level</li>
            <li>The level quiz scores earned by the learner</li>
          </ol>
          <p>These two factors (the coverage and quiz scoring), when multiplied together, will produce a level skill.</p>`
        }, {
          title: `What are the COURSE LEVELS?`,
          content: `The Safe Food Handler course has ${MAX_LEVEL_TEXT} levels of instruction.
           <ol>
              <li>Foodborne illness</li>
              <li>Time/temperature control for safety</li>
              <li>Employee hygiene</li>
              <li>Receiving food</li>
              <li>Storing food</li>
              <li>Preparing and serving food</li>
              <li>Cleaning and sanitizing</li>
           </ol>
            <p>
            The use of levels divide large groups of information into smaller, more manageable portions and allow the learner to
            track their skills and progress.</p>`
        }, {
          title: `How do COINS and PEEKS work?`,
          content: `Coins are given as users read through course material. Coins are incentives, because they can be
          used during quizzes to directly peek at course material where quiz answers are found.`
        }, {
          title: `What are the LICENSE Fees?`,
          content: `The payment of a license fee allows full participation in the certificate program. Without the
          payment of the license fee, the participant may access the certificate program as a free trial. As a free
          trial, the certificate program limits access to just two of the ${MAX_LEVEL_TEXT} levels. And no exam attempts are allowed.
          You can send invites from a free trial game, and then you and all others that join the game can pay discounted
          license fees.`
        }, {
          title: `How does the FREE TRIAL work?`,
          content: `A free trial is when a single person begins the certificate program, and has not yet paid the program
          license fee. The startup page of the Safe Food Handler app lets you start a free trial.
          <br><br>
          As a free trial, the certificate program limits access to just two of the ${MAX_LEVEL_TEXT} levels. And no exam attempts are allowed.`
        }
        ]
      }
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/views/guest/Faq.vue